// extracted by css-extract-rspack-plugin
export default {"forceGrayBackground":"forceGrayBackground-7AfQZp"};